<div appModalSwipe class="modal modal-auth l-wrapper" [ngClass]="{'modal--mobile': breakPoint.isMobile}">
  <div *ngIf="!breakPoint.isMobile" (click)="onClose()" class="modal__overlay"></div>
  <div *ngIf="breakPoint.isMobile" appOverlaySwipe class="modal__overlay"></div>

  <div appBottomSwipeSheet (swipeAnimationEnd)="onClose()"
       class="modal__container _m bottom-sheet">

    <div *ngIf="breakPoint.isMobile" class="bottom-sheet__line"></div>

    <div class="modal__close">
      <button *ngIf="!breakPoint.isMobile" type="button" class="button-icon button-icon--th-ctrl" (click)="onClose()">
        <i class="icomoon icomoon--close"></i>
      </button>

      <button *ngIf="breakPoint.isMobile" type="button" class="button-icon button-icon--th-ctrl" (click)="closeMobileModal()">
        <i class="icomoon icomoon--close"></i>
      </button>
    </div>

    <div class="modal__body auth-form l-wrapper">
      <img *ngIf="(isIiko$ | async)" class="auth-form__image" ngSrc="./assets/images/welcome-iiko.svg" alt="logo" width="202" height="240">
      <img *ngIf="(isIiko$ | async) === false" class="auth-form__image" ngSrc="./assets/images/welcome-syrve.svg" alt="logo" width="202" height="240">

      <ng-container *ngIf="authState === AuthStateType.RegisterState">
        <div class="auth-form__title h4">
          <button class="link" (click)="onBackToPhone()">
            <span class="link__icon"><i class="icomoon icomoon--arrow-left"></i></span>
            <span class="link__text">
              <span class="link__text" i18n="@@ChangePhone">Change phone</span>
              ({{ phoneCtrl.value }})
            </span>
          </button>
        </div>
        <ng-container *ngIf="loyaltyAuthProvider$ | async as loyaltyAuthProvider">
          <div class="auth-form__phone" *ngIf="(fromRussia$ | async) === false && loyaltyAuthProvider === loyaltyProviders.Card">
            <app-card-register-form [formControl]="registerCtrl"></app-card-register-form>
          </div>

          <div class="auth-form__register" *ngIf="(fromRussia$ | async) || loyaltyAuthProvider === loyaltyProviders.Digitalhub">
            <app-dh-register-form [formControl]="registerCtrl"></app-dh-register-form>
          </div>
        </ng-container>

        <div class="auth-form__code" [ngClass]="{'shake': registerErrorMessage}">
          <div class="message message--error small" *ngIf="registerErrorMessage">{{ registerErrorMessage }}</div>
        </div>

        <div class="auth-form__ctrl">
          <button class="button button--th-main"
                  [ngClass]="{'is-loading': isLoading}"
                  [disabled]="isLockSubmit || !!registerCtrl.errors"
                  (click)="onRegister()"
          >
            <span class="button__text" *ngIf="!isLockSubmit" i18n="@@Register">Register</span>
            <div class="button__spinner">
              <mat-spinner [diameter]="20"></mat-spinner>
            </div>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="authState === AuthStateType.PhoneInput">
        <div class="auth-form__title">
          <h4 i18n="@@PhoneNumber">Phone number</h4>
        </div>
        <div class="auth-form__phone">
          <mat-form-field appearance="outline">
            <ecl-phone-input
              [formControl]="phoneCtrl" [required]="false"
              (maskedPhone)="getPhone($event)" (keydown)="onKeydownPhone($event)"
              data-testid="phone"></ecl-phone-input>
            <mat-error *ngIf="phoneCtrl.hasError('required') || phoneCtrl.errors?.['requiredError']" i18n="@@ErrorMessageRequired">Required</mat-error>
            <mat-error *ngIf="phoneCtrl.errors?.['phoneCodeError']" data-testid="phone-error" i18n="@@ErrorMessageIncorrectPhone">Incorrect code</mat-error>
            <mat-error *ngIf="phoneCtrl.errors?.['singleMinLengthError']" data-testid="phone-error" i18n="@@ErrorMessageSingleMinLengthError">The phone must contain {{ phoneCtrl.errors?.['singleMinLengthError'].minLength - 1 }} digits</mat-error>
            <mat-error *ngIf="phoneCtrl.errors?.['multipleMinLengthError']" data-testid="phone-error" i18n="@@ErrorMessageMultipleMinLengthError">At least {{ phoneCtrl.errors?.['multipleMinLengthError'].minLength - 1 }} digits</mat-error>
          </mat-form-field>
          <mat-error *ngIf="phoneErrorMessage">{{ phoneErrorMessage }}</mat-error>
        </div>

        <div class="auth-form__ctrl">
          <button class="button button--th-main"
                  [ngClass]="{'is-loading': isLoading}"
                  [disabled]="isLockSubmit || phoneCtrl.errors"
                  (click)="onSubmit()"
          >
            <span class="button__text" *ngIf="!isLockSubmit" i18n="@@SendCode">Send code</span>
            <span class="button__text" *ngIf="isLockSubmit" i18n="@@SendCodeAgain">Send code again after {{ currentTime }} sec</span>
            <div class="button__spinner">
              <mat-spinner [diameter]="20"></mat-spinner>
            </div>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="authState === AuthStateType.CodeInput">
        <ng-container *ngIf="loyaltyAuthProvider$ | async as loyaltyAuthProvider">
          <div class="auth-form__title" *ngIf="loyaltyAuthProvider === loyaltyProviders.Card">
            <span class="h4" i18n="@@EnterCodeSendToEmail">Enter a code sent to your email</span>&nbsp;
            <span class="h4">{{ hiddenEmail }}</span>
          </div>

          <div class="auth-form__title" *ngIf="loyaltyAuthProvider === loyaltyProviders.Digitalhub">
            <span class="h4" i18n="@@EnterCodeSendToPhone">Enter a code sent to your phone</span>&nbsp;
            <span class="h4">{{ hiddenPhone }}</span>
          </div>
        </ng-container>

        <div class="auth-form__title h4">
          <span i18n="@@TiedTo">Tied to</span>&nbsp;
          <button class="link link--th-main link--underline" (click)="onBackToPhone()">{{ phoneCtrl.value }}</button>
        </div>

        <div class="auth-form__code" [ngClass]="{'shake': isCodeError}">
          <app-chain-input [formControl]="codeCtrl" [clearForm]="clearCode" (completeEnter)="onCompleteCode()"></app-chain-input>
          <mat-error *ngIf="codeMessage">{{ codeMessage }}</mat-error>
        </div>

        <div class="auth-form__ctrl">
          <button
            class="button button--th-main"
            [ngClass]="{'is-loading': isLoading}"
            [disabled]="isLockSubmit || isCodeError"
            (click)="onSubmit()"
          >
            <span class="button__text" *ngIf="!isLockSubmit" i18n="@@SendCode">Send code</span>
            <span class="button__text" *ngIf="isLockSubmit" i18n="@@SendCodeAgain">Send code again after {{ currentTime }} sec</span>
            <div class="button__spinner">
              <mat-spinner [diameter]="20"></mat-spinner>
            </div>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="{
        loyaltyAuthProvider: loyaltyAuthProvider$ | async,
        additionalPrivacy: additionalPrivacy$ | async,
        hasPrivacy: hasPrivacy$ | async,
        fromRussia: fromRussia$ | async
        } as data"
      >
        <ng-container *ngIf="!data.fromRussia">
          <div class="auth-form__caption" *ngIf="data.additionalPrivacy">
            <div class="small" i18n="@@UserAgreementSyrve">By continuing, you agree to the collection and processing of storage data and <a [routerLink]="['/','additional', data.additionalPrivacy.slug]" target="_blank" class="link link--th-main">the user agreement</a>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <div class="auth-form__overlay" *ngIf="isCodeSubmit">
        <mat-spinner [diameter]="60" color="accent"></mat-spinner>
      </div>
    </div>

  </div>
</div>
